import { CcrLineItem, Florder, FlorderTO } from './florder.interface';
import { Florders, FlordersTO } from './florders.interface';
import { initialStateFlordersFilter } from './florders-filter.model';

export interface Relocation extends Florder {
}

export interface Order extends Florder {
  canCreateCcr?: boolean;
  canEditCcr?: boolean; // TODO RFC1703
  ccr?: {
    UI: {
      submittingAccept: boolean;
      submittingReject: boolean;
    };
    ccrNumber: string;
    sealNumber: string;
    open: boolean;
    accepted: boolean;
    declined: boolean;
    ccrLineItems: CcrLineItem[];
  };
  corrections: {
    showCorrections: boolean;
    salesOrderNumbers: string[];
  };
}

export interface OrderTO extends FlorderTO {
  canCreateCcr?: boolean;
  canUpdateCcr?: boolean; // TODO RFC1703
  corrections: {
    showCorrections: boolean;
    salesOrderNumber?: string[];
  };
}

export interface Orders extends Florders<Order> {}

export interface OrdersTO extends FlordersTO<OrderTO> {}

export const ORDERS_INITIAL_STATE: Orders = {
  items: [],
  filter: initialStateFlordersFilter,
  loading: false,
  loaded: false,
  downloading: false,
  totalItems: null,
  filterValues: {
    loading: false,
    loaded: false,
    failed: false,
    customerIds: [],
    froms: [],
    incoterms: [],
    orderTypes: [],
    packings: [],
    pallets: [],
    tos: [],
    shippingConditions: [],
    locations: [],
  },
  maxAmountDialogShown: false,
};
